import { useEffect, useState } from 'react';
import {
  getOfferingActivityStats,
  IOfferingActivityStats,
} from 'services/ManagementReportingService';
import type { IDeliveryConfig } from './types';

const useOfferingActivityStats = ({
  slug,
  config,
}: {
  slug: string;
  config?: IDeliveryConfig;
}) => {
  const [lastAccessedOfferingStats, setLastAccessedOfferingStats] =
    useState<IOfferingActivityStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [isFetched, setIsFetched] = useState(false);

  useEffect(() => {
    const fetchOfferingActivityStats = async () => {
      setIsLoading(true);
      setError(null);
      setIsFetched(false);

      if (slug) {
        try {
          const response = await getOfferingActivityStats(slug);
          setLastAccessedOfferingStats(response);
          setIsFetched(true);
        } catch (e) {
          setError(e as Error);
          setLastAccessedOfferingStats(null);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    if (config?.hasStats) {
      fetchOfferingActivityStats();
    }
  }, [slug]);

  return {
    stats: lastAccessedOfferingStats,
    isLoading,
    error,
    isFetched,
  };
};

export default useOfferingActivityStats;
